import "./404.css";
import { useNavigate } from "react-router-dom";
import Fold from "./component/fold/Fold";

const NotFound = ({ type, title, text, isBoutton = false }) => {
  const navigate = useNavigate();

  return (
    <div className={type !== "data" ? "not-found vw vh" : "not-found"}>
      <div className="not-found-wrapper">
        <Fold type={"not-found"} code_status={404} />
        {type === "data" ? (
          <>
            <h2>{title}</h2>
            <p>{text}</p>
            {isBoutton && (
              <button className="button" onClick={() => navigate(-1)}>
                Go Back
              </button>
            )}
          </>
        ) : (
          <>
            <h2>Page Not Found</h2>
            <p>
              We are sorry, the page you requested could not be found <br />
              Please go back to the previous page
            </p>
            <button className="button" onClick={() => navigate(-1)}>
              Go Back
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default NotFound;
